import { Card, CardContent } from '@mui/material';
import { Title } from 'react-admin';

export const Help = () => (
	<Card>
		<Title title="Help" />
		<CardContent>
			
		</CardContent>
	</Card>
);

export default Help;